import { useUnit } from 'effector-react';
import $$ep from 'models/ep';
import { $global } from 'models/store-global';

import './PlanTitle.scss';

import useExecutionSteps from 'hooks/useExecutionSteps';
import useResources from 'hooks/useResources';

import custom_will from 'assets/plan-logo-custom-will.svg';
import living_trust from 'assets/plan-logo-living-trust.svg';
import simple_will from 'assets/plan-logo-simple-will.svg';

import { Document } from 'types/zod/document';

const PlanTitle = () => {
    const product = useUnit($$ep.$selectedProduct);
    const estatePlan = useUnit($$ep.stores.$epQInstance);
    const isInProgress = estatePlan?.status?.toLowerCase?.()?.includes?.('in_progress') ?? false;
    const { allDone: remainingStepsAreDone, loaded: remainingStepsLoaded } = useExecutionSteps();
    const community = useUnit($global.map((state) => state.community));
    const will = (community?.docs || []).find((doc: Document) => doc.document_type_code === 'Will');

    const { t } = useResources();

    const image = (
        <img
            className="plan-image"
            src={
                product === 'simple_product_choice'
                    ? simple_will
                    : product === 'custom_product_choice'
                    ? custom_will
                    : living_trust
            }
            alt="product"
        />
    );

    const planName = product ? t(`newDashboardPage.planName.${product}`) : t('newDashboardPage.estatePlan');
    const planNameShort = t(`newDashboardPage.planNameShort.${product}`);

    const subText = isInProgress
        ? will
            ? t('newDashboardPage.planTitle.updateInProgress')
            : t('newDashboardPage.planTitle.inProgress')
        : remainingStepsLoaded && remainingStepsAreDone
        ? t('newDashboardPage.planTitle.fullyComplete', { planName: planNameShort })
        : t('newDashboardPage.planTitle.complete');

    return (
        <div className="plan-title">
            <div className="first-line">
                {!!product && image}
                <div className="plan-name">{planName}</div>
            </div>
            <div className="second-line">{subText}</div>
        </div>
    );
};

export default PlanTitle;
